/**
 * Login / Logout commands
 */

import { oauthBrowserFlow, exchangeToken } from "../auth/oauth.js";
import { deleteCredentials, isAuthenticated, readCredentials } from "../auth/credentials.js";

interface LoginOptions {
  token?: string;
  graphqlUrl?: string;
}

export async function runLogin(opts: LoginOptions): Promise<void> {
  if (opts.token) {
    console.log("Exchanging token...");
    try {
      const creds = await exchangeToken(opts.token, opts.graphqlUrl);
      console.log(`Authenticated successfully (via token)`);
      console.log(`   GraphQL endpoint: ${creds.graphqlUrl}`);
    } catch (err: any) {
      console.error(`Token exchange failed: ${err.message}`);
      process.exit(1);
    }
    return;
  }

  if (isAuthenticated()) {
    const creds = readCredentials()!;
    console.log(`Already authenticated.`);
    console.log(`   GraphQL endpoint: ${creds.graphqlUrl}`);
    console.log(`   To re-authenticate, run: sailfish-autofix logout && sailfish-autofix login`);
    return;
  }

  try {
    const creds = await oauthBrowserFlow();
    console.log(`\nAuthenticated successfully!`);
    console.log(`   GraphQL endpoint: ${creds.graphqlUrl}`);
    process.exit(0);
  } catch (err: any) {
    console.error(`\nAuthentication failed: ${err.message}`);
    process.exit(1);
  }
}

export async function runLogout(): Promise<void> {
  if (deleteCredentials()) {
    console.log("Credentials removed.");
  } else {
    console.log("No credentials found.");
  }
}
